import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, ListItem, Collapse, List, ListItemButton, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export const NavItem = (props) => {
	const { newTab, isAccordMenu, href, icon, list, isClose, title, isAgent, onClick, ...others } = props;
	let re = new RegExp(href);
	let is_open_tab = re.test(window.location.pathname) || title === 'Developers';
	const [open, setOpen] = React.useState(is_open_tab);

	const router = useLocation();
	var active = href ? router.pathname === href : false;
	//active = list && true;
	let checkList = false;
	if (list) {
		list.map((item) => {
			if (router.pathname === item.href) {
				checkList = true;
			}
		});
		active = checkList;
	}

	return (
		<ListItem
			disableGutters
			sx={{
				display: 'flex',
				mb: 0.5,
				py: 0,
				px: 2,
			}}
			{...others}
		>
			{href ? (
				isAccordMenu ? (
					<div
						style={{
							width: '100%',
						}}
					>
						<Button
							startIcon={icon}
							disableRipple
							onClick={() => setOpen(!open)}
							// onClick={() => setOpen(!open)}
							sx={{
								backgroundColor: active && 'rgba(255,255,255, 0.08)',
								borderRadius: 1,
								color: active ? 'secondary.main' : 'neutral.300',
								fontWeight: active && 'fontWeightBold',
								justifyContent: 'flex-start',
								px: 3,
								py: 0,
								textAlign: 'left',
								textTransform: 'none',
								width: '100%',
								'& .MuiButton-startIcon': {
									color: active ? 'secondary.main' : 'neutral.400',
								},
								'&:hover': {
									backgroundColor: 'rgba(255,255,255, 0.08)',
								},
							}}
						>
							<Box sx={{ flexGrow: 4 }}>
								{title}
								{list && (
									<IconButton aria-label="expand row" size="small">
										{isAccordMenu && (open ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />)}
									</IconButton>
								)}
							</Box>
							{/* <ExpandMore/> */}
						</Button>
						{open && list ? (
							<Collapse in={true} timeout="auto" unmountOnExit>
								<List component="div" disablePadding>
									{list.map((item) => (
										<Link to={item.href}>
											<ListItemButton
												sx={{
													pl: 4,
													py: 0.1,
													borderRadius: 1,
													'&:hover': {
														backgroundColor: 'rgba(255,255,255, 0.08)',
													},
												}}
											>
												<ListItemIcon
													style={{ color: checkList && router.pathname === item.href ? '#10B981' : '#dadada' }}
													sx={{
														minWidth: '29px',
													}}
												>
													{item.icon}
												</ListItemIcon>
												<ListItemText
													primary={item.title}
													style={{ color: checkList && router.pathname === item.href ? '#10B981' : '#dadada' }}
												/>
											</ListItemButton>
										</Link>
									))}
								</List>
							</Collapse>
						) : (
							<div></div>
						)}
					</div>
				) : newTab ? (
					<a
						style={{
							width: '100%',
							background: 'white',
							borderRadius: '5px',
						}}
						href={href}
						target="_blank"
						rel="noopener noreferrer"
					>
						<Button
							startIcon={icon}
							disableRipple
							onClick={() => setOpen(!open)}
							// onClick={() => setOpen(!open)}
							sx={{
								backgroundColor: active && 'rgba(255,255,255, 0.08)',
								borderRadius: 1,
								color: active ? 'secondary.main' : 'neutral.300',
								fontWeight: active && 'fontWeightBold',
								justifyContent: 'flex-start',
								px: 3,
								py: 0.5,
								textAlign: 'left',
								textTransform: 'none',
								width: '100%',
								'& .MuiButton-startIcon': {
									color: active ? 'secondary.main' : 'neutral.400',
								},
								'&:hover': {
									backgroundColor: 'rgba(255,255,255, 0.08)',
								},
							}}
						>
							<Box sx={{ flexGrow: 4, color: '#009687' }}>{title}</Box>
						</Button>
					</a>
				) : (
					<Link
						style={{
							width: '100%',
						}}
						to={href}
					>
						<Button
							startIcon={icon}
							disableRipple
							onClick={() => setOpen(!open)}
							// onClick={() => setOpen(!open)}
							sx={{
								backgroundColor: active && 'rgba(255,255,255, 0.08)',
								borderRadius: 1,
								color: active ? 'secondary.main' : 'neutral.300',
								fontWeight: active && 'fontWeightBold',
								justifyContent: 'flex-start',
								px: 3,
								py: 0.6,
								textAlign: 'left',
								textTransform: 'none',
								width: '100%',
								'& .MuiButton-startIcon': {
									color: active ? 'secondary.main' : 'neutral.400',
								},
								'&:hover': {
									backgroundColor: 'rgba(255,255,255, 0.08)',
								},
							}}
						>
							<Box sx={{ flexGrow: 4 }}>
								{title}
								{list && (
									<IconButton aria-label="expand row" size="small">
										{active ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
									</IconButton>
								)}
							</Box>
							{/* <ExpandMore/> */}
						</Button>
						{active && list ? (
							<Collapse in={true} timeout="auto" unmountOnExit>
								<List sx={{ marginTop: '3px' }} component="div" disablePadding>
									{list.map((item) => (
										<Link to={item.href}>
											<ListItemButton
												sx={{
													pl: 4,
													borderRadius: 1,
													'&:hover': {
														backgroundColor: 'rgba(255,255,255, 0.08)',
													},
												}}
											>
												<ListItemIcon
													style={{ color: active && router.pathname === item.href ? '#10B981' : '#dadada' }}
													sx={{
														minWidth: '29px',
													}}
												>
													{item.icon}
												</ListItemIcon>
												<ListItemText
													primary={item.title}
													style={{ color: active && router.pathname === item.href ? '#10B981' : '#dadada' }}
												/>
											</ListItemButton>
										</Link>
									))}
								</List>
							</Collapse>
						) : (
							<div></div>
						)}
					</Link>
				)
			) : (
				<Button
					onClick={onClick}
					startIcon={icon}
					disableRipple
					sx={{
						backgroundColor: active && 'rgba(255,255,255, 0.08)',
						borderRadius: 1,
						color: active ? 'secondary.main' : 'neutral.300',
						fontWeight: active && 'fontWeightBold',
						justifyContent: 'flex-start',
						px: 3,
						textAlign: 'left',
						textTransform: 'none',
						width: '100%',
						'& .MuiButton-startIcon': {
							color: active ? 'secondary.main' : 'neutral.400',
						},
						'&:hover': {
							backgroundColor: 'rgba(255,255,255, 0.08)',
						},
					}}
				>
					<Box sx={{ flexGrow: 1 }}>{title}</Box>
				</Button>
			)}
		</ListItem>
	);
};

NavItem.propTypes = {
	href: PropTypes.string,
	icon: PropTypes.node,
	title: PropTypes.string,
};
